var header;

header = function () {
  var headerTimeout;
  $("#navigation a").on("click", function (e) {
    if ($("#header").hasClass("faded")) {
      e.preventDefault();
      return $("#header").removeClass("faded").addClass("pinned");
    }
  });
  if (!$("#header").hasClass("homepage")) {
    $(window).off("mousemove");
    $("#header").off("mouseenter");
    return $("#header").off("mouseleave");
  } else {
    headerTimeout = null;
    $(document).on("page:fetch", function (e) {
      return window.clearTimeout(headerTimeout);
    });
    $(window).mousemove(function () {
      var $this;
      $this = $("#header");
      if (!$this.hasClass("pinned")) {
        $this.removeClass("inactive");
        window.clearTimeout(headerTimeout);
        return (headerTimeout = window.setTimeout(function () {
          $this = $("#header");
          if (!$this.hasClass("pinned") && $this.hasClass("homepage")) {
            return $this.addClass("inactive");
          }
        }, 1000));
      }
    });
    $("#header").on("mouseenter", function (e) {
      $(this).addClass("pinned");
      return window.clearTimeout(headerTimeout);
    });
    return $("#header").on("mouseleave", function (e) {
      return $(this).removeClass("pinned");
    });
  }
};

$(document).ready(header);

$(document).on("page:load", header);

// ---
// generated by coffee-script 1.9.2
